import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Link } from '@mui/material';

const SiteLegalRedirect = ({ to }: { to: string }) => {
  const { search, hash } = useLocation();
  const destination = `${to}${search}${hash}`;

  useEffect(() => {
    window.location.replace(destination);
  }, [destination]);

  return <Link href={destination}>Abrir documento no site da Giro</Link>;
};

export default SiteLegalRedirect;
